import { iSchemaPodani } from '../../../types/submitsInfo.types'
import { useStylesUpload } from './stylesUpload'
import UploadFiles from './UploadFiles'
import UploadInput from './UploadInput'

interface iUploadBox {
  name: string,
  dataSchema: iSchemaPodani
}

const UploadBox = ({ name, dataSchema }: iUploadBox) => {
  const classes = useStylesUpload()

  const {
    prilohy: prilohySchema,
    pocetPriloh: pocetPilohSchema,
    velikostPriloh: velikostPrilohSchema,
  } = dataSchema.properties

  const prilohyItemsSchema = prilohySchema?.items?.properties ?? {}

  const maxFiles = pocetPilohSchema?.maximum || prilohySchema?.maxItems
  const maxSize = prilohyItemsSchema.velikostOriginalu?.maximum
  const minSize = prilohyItemsSchema.velikostOriginalu?.minimum
  const maxSizeAll = velikostPrilohSchema?.maximum

  // omezeujeme jen na pripona ze schema - neresime mimeType
  const acceptFileMimeTypes: string[] = prilohyItemsSchema.pripona?.enum ?? []

  return (
    <div className={classes.uploadWrap}>
      <UploadFiles name={name}/>
      <UploadInput
        name={name}
        // minFiles={minFiles}
        maxFiles={maxFiles}
        maxSize={maxSize}
        minSize={minSize}
        maxSizeAll={maxSizeAll}
        acceptFileExts={acceptFileMimeTypes}
      />
    </div>
  )
}
export default UploadBox
